module.exports = __webpack_public_path__ + "img/pistol.nailgun.527389aa.png";